import { homeAnnouncementsSection, homeRowMeldungen, homeShowMoreAnnouncementsButton } from "@modules/global/dom.ts"

import { scrollPageTo } from "@modules/advert-cards/home.ts"

const announcementsStorageKey = "openAnnouncements"
const gutter = 19

const calculateAndSetHeights = () => {
    const announcementsSection = homeAnnouncementsSection()
    if (!announcementsSection) return

    const announcementsContainer = homeRowMeldungen() as HTMLElement
    const card = announcementsSection.querySelector<HTMLDivElement>(".anzeige-meldung")
    const title = announcementsSection.querySelector<HTMLDivElement>(".stripe-title-meldungen")

    if (!announcementsContainer || !card || !title) return

    const isOpen = sessionStorage.getItem(announcementsStorageKey) === "1"

    announcementsContainer.style.height = "auto"
    const maxHeight = announcementsContainer.offsetHeight
    announcementsContainer.dataset.maxHeight = maxHeight.toString()

    const cardHeight = card.clientHeight
    const titleHeight = title.clientHeight
    const minHeight = cardHeight + titleHeight + gutter

    const moreCardsSection = document.querySelector<HTMLDivElement>("#meldungen .more-content.row.section-1")
    if (!moreCardsSection) return

    if (isOpen) {
        announcementsContainer.style.height = `${maxHeight}px`
        announcementsSection.classList.add("more-is-open")
    } else {
        announcementsContainer.style.height = `${minHeight}px`
        announcementsSection.classList.remove("more-is-open")
    }
}

let announcementsTimeout: Timer | number = 0
const setTimeoutForCalculateAndSetHeights = () => {
    clearTimeout(announcementsTimeout)
    announcementsTimeout = setTimeout(calculateAndSetHeights, 50)
}

const showAnnouncements = () => {
    const announcementsSection = homeAnnouncementsSection()
    if (!announcementsSection) return

    const announcementsContainer = homeRowMeldungen() as HTMLElement
    if (!announcementsContainer) return

    const maxHeight = Number.parseInt(announcementsContainer.dataset.maxHeight ?? "0")
    if (maxHeight === 0) return

    const moreCardsSection = document.querySelector<HTMLDivElement>("#meldungen .more-content.row.section-1")
    if (!moreCardsSection) return

    announcementsContainer.style.transition = "height 0.5s"
    announcementsContainer.style.height = `${maxHeight}px`
    announcementsSection.classList.add("more-is-open")
    sessionStorage.setItem(announcementsStorageKey, "1")
}

const hideAnnouncements = () => {
    const announcementsSection = homeAnnouncementsSection()
    if (!announcementsSection) return

    const announcementsContainer = homeRowMeldungen() as HTMLElement
    const card = announcementsSection.querySelector<HTMLDivElement>(".anzeige-meldung")
    const title = announcementsSection.querySelector<HTMLDivElement>(".stripe-title-meldungen")

    if (!announcementsContainer || !card || !title) return

    const cardHeight = card.clientHeight
    const titleHeight = title.clientHeight
    const minHeight = cardHeight + titleHeight + gutter
    const moreCardsSection = document.querySelector<HTMLDivElement>("#meldungen .more-content.row.section-1")
    if (!moreCardsSection) return

    announcementsContainer.style.transition = "height 0.5s"
    announcementsContainer.style.height = `${minHeight}px`
    announcementsSection.classList.remove("more-is-open")
    sessionStorage.setItem(announcementsStorageKey, "0")
    scrollPageTo(announcementsSection)
}

const toggleAnnouncements = (e: Event) => {
    e.preventDefault()
    const announcementsSection = homeAnnouncementsSection()
    if (!announcementsSection) return

    if (announcementsSection.classList.contains("more-is-open")) {
        hideAnnouncements()
    } else {
        showAnnouncements()
    }
}

export const initAnnouncements = () => {
    const announcementsSection = homeAnnouncementsSection()
    const announcementsButton = homeShowMoreAnnouncementsButton()

    if (!announcementsSection || !announcementsButton) {
        return
    }

    const announcementsContainer = homeRowMeldungen() as HTMLElement
    if (!announcementsContainer) return

    const card = announcementsSection.querySelector<HTMLDivElement>(".anzeige-meldung")
    const title = announcementsSection.querySelector<HTMLDivElement>(".stripe-title-meldungen")

    if (!card || !title) {
        announcementsSection.style.display = "none"
        return
    }

    announcementsContainer.style.overflow = "hidden"

    calculateAndSetHeights()

    announcementsButton.addEventListener("click", toggleAnnouncements)
    window.addEventListener("resize", setTimeoutForCalculateAndSetHeights)
}
